import {AxiosError} from 'axios';
import {PaginatedData} from 'web-library/models/List';
import {GET_TRANSACTION_LOG_QUERY_KEY} from 'web-library/constants/queryKeys';
import {
  TransactionLogResponseContentObject
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import {GET_TRANSACTION_LOG_URL} from 'web-library/constants/apiUrls';
import {ApiPathParam} from 'web-library/models/SearchParamSchema';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  apiPathParam: ApiPathParam;
  requestType: string;
  uuid: string;
  onSuccess?: (res: PaginatedData<TransactionLogResponseContentObject>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  enabled: boolean;
}

export const useGetTransactionLog = ({
                                       apiPathParam,
                                       requestType,
                                       uuid,
                                       onError,
                                       onSuccess,
                                       enabled,
                                     }: Input) => {
  const getTransactionLog = async () => {
    const res = await axiosClient.get<PaginatedData<TransactionLogResponseContentObject>>(
        GET_TRANSACTION_LOG_URL(requestType, uuid, apiPathParam)
    );

    return res.data;
  };

  return useCustomQuery([GET_TRANSACTION_LOG_QUERY_KEY, uuid], getTransactionLog, {
    onSuccess,
    onError,
    enabled,
  });
};
